/**
 * Petty cash layout guard — Layer 3 of the module gate (ADR-0046).
 *
 * Petty cash is part of the 1.0-withheld `cash` module (returns in 1.2; bank
 * accounts stay in). This layout route redirects a typed `/petty-cash` URL — and
 * every nested child (`/cash/petty-cash/new`, `/cash/petty-cash/count`, …) — to `/` unless
 * the workspace is entitled to `cash`, which no 1.0 plan grants. Renders only an
 * `<Outlet/>`. @see docs/adr/0046-withheld-1.0-modules.md
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireModule } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/cash/petty-cash")({
  beforeLoad: requireModule("cash"),
  component: Outlet,
});
